// extracted by mini-css-extract-plugin
export default {"container":"Nj-z","blurb":"Oj-z","links":"Pj-z"};